export const HERO_CONSTANTS = {
  title: "Infrastructure as a Service ",
  content:
    "Leverage our comprehensive Infrastructure as a Service (IaaS) to seamlessly deploy, manage, and scale your IT resources, ensuring flexibility and robust security for your enterprise.",
  button: {
    label: "Discover Our IaaS Offerings",
    link: "#services",
  },
};
